import { InvoiceClockIcon } from './InvoiceClockIcon';

/**
 * author: Jeff Anders
 * id C6B8DF23-3526-4052-BB03-37F479F3B5B6
 * name invoice-clock
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-clock.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceScheduledIcon = InvoiceClockIcon;
export default InvoiceScheduledIcon